import React from "react"
import { Slot } from "@radix-ui/react-slot"

import { sanitizeHtml } from "@/lib/sanitizeHtml"
import { cn } from "@/lib/utils"
import { Typography } from "@/components/ui/atoms"

interface ISimpleListProps {
  asChild?: boolean
  title: string
  list: Array<string>
  isInArticle?: boolean
}

const SimpleList = React.forwardRef<HTMLDivElement, ISimpleListProps>(
  ({ asChild = false, title, list, isInArticle, ...props }, ref) => {
    const firstHalf = list.slice(0, Math.ceil(list.length / 2))
    const secondHalf = list.slice(Math.ceil(list.length / 2), list.length)

    const Component = asChild ? Slot : "div"
    return (
      <Component
        className={cn("simple-list", isInArticle ? "" : "container")}
        ref={ref}
        {...props}
      >
        <div
          className={cn(
            "flex flex-col bg-neutral-200",
            isInArticle ? "" : "py-12"
          )}
        >
          <Typography
            as="h2"
            variant="headingS"
            className="w-full rounded-t-100 bg-secondary-500 p-6 lg:px-9"
          >
            {title}
          </Typography>
          <div className="rounded-b-100 bg-neutral-100 p-6 pb-5 lg:p-9 lg:pb-8">
            <ul className="simple-list gap ml-0 grid list-none lg:grid-cols-2">
              <span>
                {firstHalf.map((el) => {
                  return (
                    <li
                      className="ml-7 pb-3 text-neutral-400 lg:mr-7"
                      key={el}
                      dangerouslySetInnerHTML={{ __html: sanitizeHtml(el) }}
                    ></li>
                  )
                })}
              </span>
              <span>
                {secondHalf.map((el) => {
                  return (
                    <li
                      className="ml-7 pb-3 text-neutral-400"
                      key={el}
                      dangerouslySetInnerHTML={{ __html: sanitizeHtml(el) }}
                    ></li>
                  )
                })}
              </span>
            </ul>
          </div>
        </div>
      </Component>
    )
  }
)
SimpleList.displayName = "SimpleList"

export { SimpleList, type ISimpleListProps }
